module.exports = __webpack_public_path__ + "img/Talk-to-us.43a0a24d.png";